"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _GoBackButton = _interopRequireDefault(require("../GoBackButton/GoBackButton"));
var _TagsGroup = _interopRequireDefault(require("../../TagsGroup/TagsGroup"));
var _TextWithSyllabification = _interopRequireDefault(require("../TextWithSyllabification/TextWithSyllabification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-vacancy {\n  display: flex;\n  flex-direction: column;\n  max-width: 640px;\n  margin: auto; }\n  .sia-vacancy .top {\n    max-width: 600px; }\n  .sia-vacancy .bottom {\n    display: flex;\n    flex-direction: column;\n    gap: 24px; }\n  .sia-vacancy a {\n    color: #000000; }\n\n@media (max-width: 42rem) {\n  .sia-vacancy {\n    margin: 0px 16px; } }\n";
  const fileName = "SIAVacancy_SIAVacancy";
  const element = document.querySelector("style[data-sass-component='SIAVacancy_SIAVacancy']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAVacancyText = _ref => {
  let {
    value,
    label,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value && label && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-04"
  }, label), /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "sia-text-10",
    lang: lang
  }, value)));
};
const SIAVacancy = _ref2 => {
  let {
    item,
    lang,
    history
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-vacancy"
  }, /*#__PURE__*/_react.default.createElement(_GoBackButton.default, {
    history: history,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "top sia-margin-05-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-03 sia-margin-02-bottom",
    dangerouslySetInnerHTML: {
      __html: item.prefix
    }
  }), /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "title sia-text-12",
    lang: lang
  }, item.title), item.pensum && item.location && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [{
      label: item.pensum || '',
      type: 'primary'
    }, {
      label: item.location || '',
      type: 'quaternary'
    }]
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom"
  }, item.intro && /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "sia-text-10",
    lang: lang
  }, item.intro), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.vision,
    label: item.vision_label,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.job_location,
    label: item.location_label,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.job_function,
    label: item.job_function_label,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.job_function_commission,
    label: item.function_commission_label,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.job_profile,
    label: item.job_profile_label,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.job_offer,
    label: item.job_offer_label,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.expect,
    label: item.expect_label,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(SIAVacancyText, {
    value: item.job_contact,
    label: item.job_contact_label,
    lang: lang
  })));
};
SIAVacancy.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = exports.default = SIAVacancy;